/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { L, LTags } from '../../../frontend/common/common.js'
import Avatar from '../../../frontend/views/components/Avatar.vue'
import Loading from '../../../frontend/views/components/Loading.vue'
import LoginForm from '../../../frontend/views/containers/access/LoginForm.vue'
import SignupForm from '../../../frontend/views/containers/access/SignupForm.vue'
import sbp from '@sbp/sbp'
import SvgBrokenLink from '../../../frontend/assets/svgs/broken-link.svg'
import SvgCreateGroup from '../../../frontend/assets/svgs/create-group.svg'
import { LOGIN } from '../../../frontend/utils/events.js'
import { mapGetters, mapState } from 'vuex'
import { INVITE_STATUS } from '@chelonia/lib/constants'
import { PROFILE_STATUS } from '../../../frontend/model/contracts/shared/constants.js'
import { keyId } from '@chelonia/crypto'

let syncFinished = false
sbp('okTurtles.events/once', LOGIN, () => { syncFinished = true })

const __vue_script__ = ({
  name: 'Join',
  components: {
    Loading,
    LoginForm,
    SignupForm,
    Avatar,
    SvgBrokenLink,
    SvgCreateGroup
  },
  data () {
    return {
      ephemeral: {
        pageStatus: 'LOADING',
        invitation: {},
        groupInfo: {},
        hash: null
      }
    }
  },
  computed: {
    ...mapGetters(['ourIdentityContractId']),
    ...mapState(['currentGroupId']),
    pageStatus: {
      get () { return this.ephemeral.pageStatus },
      set (status) {
        const possibleStatus = ['LOADING', 'SIGNING', 'LOGGING', 'INVALID', 'EXPIRED', 'JOINED']
        if (!possibleStatus.includes(status)) {
          throw new Error(`Bad status: ${status}. Use one of the following: ${possibleStatus.join(', ')}`)
        }
        this.ephemeral.pageStatus = status
      }
    }
  },
  mounted () {
    // For some reason in some Cypress tests it loses the route hash when initialized is called
    this.ephemeral.hash = new URLSearchParams(this.$route.hash.slice(1))
    if (syncFinished || !this.ourIdentityContractId) {
      this.initialize()
    } else {
      sbp('okTurtles.events/once', LOGIN, () => this.initialize())
    }
  },
  methods: {
    async initialize () {
      try {
        const messageToAskAnother = L('You should ask for a new one. Sorry about that!')
        const groupId = this.ephemeral.hash.get('groupId')
        const secret = this.ephemeral.hash.get('secret')
        if (!groupId || !secret) {
          console.error('Invalid invite link: missing group ID or secret')
          this.ephemeral.errorMsg = messageToAskAnother
          this.pageStatus = 'INVALID'
          return
        }
        const state = await sbp('chelonia/latestContractState', groupId)
        const publicKeyId = keyId(secret)
        const invite = state._vm.invites[publicKeyId]
        if (invite?.expires < Date.now()) {
          console.log('Join.vue error: Link is already expired.')
          this.ephemeral.errorMsg = messageToAskAnother
          this.pageStatus = 'EXPIRED'
          return
        } else if (invite?.initialQuantity > 0 && !invite.quantity) {
          console.log('Join.vue error: Link is already used.')
          this.ephemeral.errorMsg = messageToAskAnother
          this.pageStatus = 'INVALID'
          return
        } if (invite?.status !== INVITE_STATUS.VALID) {
          console.error('Join.vue error: Link is not valid.')
          this.ephemeral.errorMsg = messageToAskAnother
          this.pageStatus = 'INVALID'
          return
        }
        if (this.ourIdentityContractId) {
          const targetGroupId = this.ephemeral.hash?.get('groupId') || ''
          const targetGroupState = this.$store.state[targetGroupId] || {}

          if (this.currentGroupId && [PROFILE_STATUS.ACTIVE, PROFILE_STATUS.PENDING].includes(targetGroupState?.profiles?.[this.ourIdentityContractId])) {
            this.goToDashboard()
          } else if (this.checkAlreadyJoinedGroup(targetGroupId)) { // if the user is already part of the target group.
            this.ephemeral.groupInfo = {
              name: targetGroupState.settings?.groupName || '',
              id: targetGroupId
            }
            this.pageStatus = 'JOINED'

            return
          } else {
            await this.accept()
          }
          return
        }
        const creatorID = this.ephemeral.hash.get('creatorID')
        const creatorUsername = this.ephemeral.hash.get('creatorUsername')
        const who = creatorUsername || creatorID
        const message = who
          ? L('{who} invited you to join their group!', { who })
          : L('You were invited to join')

        this.ephemeral.invitation = {
          groupName: this.ephemeral.hash.get('groupName') ?? L('(group name unavailable)'),
          creatorID,
          creatorUsername,
          message
        }
        this.pageStatus = 'SIGNING'
      } catch (e) {
        console.error(e)
        this.ephemeral.errorMsg = `${L('Something went wrong. Please, try again.')} ${e.message}`
        this.pageStatus = 'INVALID'
      }
    },
    isStatus (status) {
      return this.pageStatus === status
    },
    goHome () {
      this.$router.push({ path: '/' })
    },
    checkAlreadyJoinedGroup (targetGroupId) {
      if (this.ourIdentityContractId) {
        const myGroups = this.$store.state[this.ourIdentityContractId]?.groups || {}
        return myGroups[targetGroupId] && !myGroups[targetGroupId]?.hasLeft
      } else return false
    },
    goToDashboard (toGroupId) {
      if (toGroupId && this.currentGroupId !== toGroupId) {
        sbp('gi.app/group/switch', toGroupId)
      }

      this.$router.push({ path: '/dashboard' })
    },
    async accept () {
      this.ephemeral.errorMsg = null
      const groupId = this.ephemeral.hash.get('groupId')
      const secret = this.ephemeral.hash.get('secret')

      const profileStatus = this.$store.state.contracts[groupId]?.profiles?.[this.ourIdentityContractId]?.status
      if ([PROFILE_STATUS.ACTIVE, PROFILE_STATUS.PENDING].includes(profileStatus)) {
        return this.goToDashboard()
      }
      try {
        await sbp('gi.app/group/joinWithInviteSecret', groupId, secret)
        // this.pageStatus = 'WELCOME'
      } catch (e) {
        console.error('Join.vue accept() error:', e)
        this.ephemeral.errorMsg = e.message

        const alreadyJoinedErr = this.checkAlreadyJoinedGroup(groupId)
        this.pageStatus = alreadyJoinedErr ? 'JOINED' : 'INVALID'
        if (alreadyJoinedErr) {
          // if errored by attempting to join an already-joined group, show a different UI informing it.
          const targetGroupState = this.$store.state[groupId] || {}

          this.ephemeral.groupInfo = {
            name: targetGroupState.settings?.groupName || '',
            id: groupId
          }
        } else {
          sbp('gi.ui/prompt', {
            heading: L('Failed to join the group'),
            question: L('Error details:{br_}{err}', { err: e.message, ...LTags() }),
            primaryButton: L('Close')
          })
        }
      }
    }
  }
}        )

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"c-logo",attrs:{"src":"/assets/images/logo-transparent.png"}}),(_vm.isStatus("LOADING"))?_c('loading',{attrs:{"theme":"fullView"}}):_c('div',{staticClass:"c-page"},[(_vm.isStatus("SIGNING") || _vm.isStatus("LOGGING"))?_c('div',[_c('div',{staticClass:"c-header"},[_c('div',{staticClass:"c-avatars"},[(_vm.ephemeral.invitation.groupPicture)?_c('avatar',{staticClass:"c-avatars-group",attrs:{"src":_vm.ephemeral.invitation.groupPicture,"size":"lg"}}):_vm._e(),(_vm.ephemeral.invitation.creatorPicture)?_c('avatar',{staticClass:"c-avatars-creator",attrs:{"src":_vm.ephemeral.invitation.creatorPicture}}):_vm._e()],1),_c('h1',{staticClass:"is-title-1 c-title",attrs:{"data-test":"groupName"}},[_vm._v(_vm._s(_vm.ephemeral.invitation.groupName))]),_c('p',{staticClass:"has-text-1",attrs:{"data-test":"invitationMessage"}},[_vm._v(_vm._s(_vm.ephemeral.invitation.message))])]),_c('div',{staticClass:"card"},[(_vm.isStatus("SIGNING"))?_c('signup-form',{attrs:{"postSubmit":_vm.accept}}):_c('login-form',{attrs:{"postSubmit":_vm.accept}})],1),(_vm.isStatus("SIGNING"))?_c('p',{staticClass:"c-switchEnter"},[_c('i18n',[_vm._v("Already have an account?")]),_vm._v(" "),_c('i18n',{staticClass:"link",attrs:{"tag":"button"},on:{"click":function($event){_vm.pageStatus = "LOGGING"}}},[_vm._v("Log in")])],1):_c('p',{staticClass:"c-switchEnter"},[_c('i18n',[_vm._v("Not on Group Income yet?")]),_vm._v(" "),_c('i18n',{staticClass:"link",attrs:{"tag":"button"},on:{"click":function($event){_vm.pageStatus = "SIGNING"}}},[_vm._v("Create an account")])],1)]):(_vm.isStatus("JOINED"))?_c('div',{staticClass:"c-joined"},[_c('svg-create-group',{staticClass:"c-svg"}),_c('i18n',{staticClass:"is-title-1",attrs:{"tag":"h1","data-test":"pageTitle","args":{ groupName: _vm.ephemeral.groupInfo.name }}},[_vm._v("You are already a member of '{groupName}'")]),_c('i18n',{staticClass:"has-text-1",attrs:{"tag":"p","data-test":"helperText"}},[_vm._v("You cannot join already joined group.")]),_c('i18n',{staticClass:"c-goHome",attrs:{"tag":"button"},on:{"click":function($event){return _vm.goToDashboard(_vm.ephemeral.groupInfo.id)}}},[_vm._v("Go to dashboard")])],1):(_vm.isStatus("INVALID"))?_c('div',{staticClass:"c-broken"},[_c('svg-broken-link',{staticClass:"c-svg"}),_c('i18n',{staticClass:"is-title-1",attrs:{"tag":"h1","data-test":"pageTitle","args":_vm.LTags()}},[_vm._v("Oh no! {br_}This invite is not valid")]),_c('p',{staticClass:"has-text-1",attrs:{"data-test":"helperText"}},[_vm._v(_vm._s(_vm.ephemeral.errorMsg))]),_c('i18n',{staticClass:"c-goHome",attrs:{"tag":"button"},on:{"click":_vm.goHome}},[_vm._v("Take me home")])],1):(_vm.isStatus("EXPIRED"))?_c('div',{staticClass:"c-broken"},[_c('svg-broken-link',{staticClass:"c-svg"}),_c('i18n',{staticClass:"is-title-1",attrs:{"tag":"h1","data-test":"pageTitle","args":_vm.LTags()}},[_vm._v("Oh no! {br_}This invite is already expired")]),_c('p',{staticClass:"has-text-1",attrs:{"data-test":"helperText"}},[_vm._v(_vm._s(_vm.ephemeral.errorMsg))]),_c('i18n',{staticClass:"c-goHome",attrs:{"tag":"button"},on:{"click":_vm.goHome}},[_vm._v("Take me home")])],1):_vm._e()])],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-66143ea6_0", { source: ".c-logo[data-v-66143ea6]{min-width:8rem;width:8rem;margin:auto}@media screen and (min-width:769px),print{.c-logo[data-v-66143ea6]{position:absolute;top:1.5rem;left:1.5rem}}.c-page[data-v-66143ea6]{max-width:33rem;margin:auto;height:100%}.c-welcome[data-v-66143ea6]{margin-top:-1.5rem}.c-header[data-v-66143ea6]{margin-top:1rem;display:flex;flex-direction:column;align-items:center}.c-header .c-title[data-v-66143ea6]{order:2}@media screen and (min-width:769px),print{.c-header[data-v-66143ea6]{margin-top:2.5rem}}.c-avatars[data-v-66143ea6]{position:relative;margin-bottom:1.5rem}@media screen and (min-width:769px),print{.c-avatars .c-avatars-group.is-lg[data-v-66143ea6]{width:8rem;height:8rem}}.c-avatars .c-avatars-creator[data-v-66143ea6]{position:absolute;bottom:0;right:0;border:2px solid #fff}.card[data-v-66143ea6]{padding:1.5rem 1rem;margin-top:1.5rem}@media screen and (min-width:769px),print{.card[data-v-66143ea6]{padding:2.5rem}}.c-switchEnter[data-v-66143ea6]{margin-top:1.5rem;text-align:center}.c-broken[data-v-66143ea6],.c-joined[data-v-66143ea6]{margin-top:20vh;text-align:center}.c-broken .is-title-1[data-v-66143ea6],.c-joined .is-title-1[data-v-66143ea6]{margin-top:3rem;margin-bottom:.5rem}.c-broken .c-goHome[data-v-66143ea6],.c-joined .c-goHome[data-v-66143ea6]{margin-top:2rem}@media screen and (min-width:769px),print{.c-debug[data-v-66143ea6]{position:absolute;bottom:1rem;right:1rem}}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-66143ea6"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "style>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__